<div class="carousel-img-galery">
  <div class="carousel-viewport">
    <div
      class="carousel-track"
      [style.transform]="transform"
      [style.transitionDuration.ms]="transitionMs"
    >
      <div class="carousel-slide" *ngFor="let item of listaImagem; let i = index">
        <img [src]="item && (item.urlS3 || item.src)" [alt]="item.nome" />
      </div>
    </div>
  </div>

  <div class="carousel-pagination">
    <button type="button" class="btn btn-primary rounded nav" (click)="navigate('F')">
      <i class="fa fa-arrow-left"></i>
    </button>
    <div class="carousel-index-selection">
      <ng-container *ngFor="let item of listaImagem; let i = index">
        <button
          type="button"
          class="btn btn-primary rounded index-btn"
          [class.active]="i === currentIndex"
          (click)="changeIndex(i)"
        >
          {{ i + 1 }}
        </button>
      </ng-container>
    </div>
    <button type="button" class="btn btn-primary rounded nav" (click)="navigate('B')">
      <i class="fa fa-arrow-right"></i>
    </button>
  </div>
</div>
